export const breakpoints = {
	xxsmall: 410,
	xsmall: 743,
	small: 1023,
	medium: 1290,
	large: 1440,
	xlarge: 1700,
	xxlarge: 2000,
}

export const grid = {
	col_number: 24,
	gutter: 12,
	gutter__mobile: 4,
	max_width: 106.25,
	row_margin: 48,
	row_margin__mobile: 8,
}
